let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9SQ85")).then(() => parcelRequire('hdhNx'));